import React, { Fragment } from 'react'
import Capture from '../../components/Capture/Capture'
import Nav from '../../components/NavBar/Nav'
import Footer from '../../components/Footer/Footer'

const index = () => {
  return (
    <Fragment>
        <Nav/>
        <Capture/>
        <Footer/>
    </Fragment>
  )
}

export default index